import type { SubEnvironment } from '@change-corgi/config/environments';

import { facebookNamespaces } from './data';

export function getFacebookNamespace(environment: SubEnvironment): string {
	// eslint-disable-next-line security/detect-object-injection
	return facebookNamespaces[environment];
}
